<script>
import NotificationService from '../../services/notifications';

import CommonConstants from '../../common/Constants';
import Utils from '../../common/Utils';
import Toolbar from 'primevue/toolbar';

import ResponsiveButton from '../../components/generic/ResponsiveButton.vue'

import { useVuelidate } from "@vuelidate/core";

export default {
  setup: () => ({ v$: useVuelidate() }),
  components: {
    Toolbar,
    ResponsiveButton,
  },
  data() {
    return {
      submitted: false,
      currentThread: false
    }
  },
  validations() {
    return {
      data: {
        thread: {},
      }
    }
  },
  mounted() {
    this.$store.dispatch('security/setNavbarTitle', 'thread.page_title');
    NotificationService.getThreads(response => {
      if (response.success) {
        this.$store.dispatch("notifications/setThreads", response.data);
        if (response.data.length){
          this.currentThread = response.data[0];
          if(!Array.isArray(this.currentThread?.users)){
            this.currentThread.users = this.currentThread?.users.split(',')
          }
        }
      }
    });
  },
  computed: {
    constants() {
      return CommonConstants;
    },
    utils() {
      return Utils;
    }
  },
  methods: {
    goBack() {
      this.$router.back();
    },
    showThread(thread) {
      this.currentThread = thread;
      if(!Array.isArray(this.currentThread?.users)){
        this.currentThread.users = this.currentThread?.users.split(',')
      }
      // this.$refs.widgetChat.scrollIntoView({behavior: "smooth", block: "end", inline: "nearest"});
    },
    newThread() {
      this.$router.push('thread');
    }
  }
}

</script>

<template>
  <Toolbar style="padding: 0;">
    <template #start>
      <ResponsiveButton :label="$t('btn.back')" icon="pi pi-arrow-left" class="p-button-outlined p-button-sm m-1"
        @click="goBack" />
      <ResponsiveButton :label="$t('thread.btn.newThread')" icon="pi pi-plus" class="p-button-sm m-1"
        @click="$router.push(`/threads/0`)" />
    </template>
  </Toolbar>
  <div class="grid grid-thread">
    <div class="col-3 sidebar pr-0" v-if="$store.state.notifications.threads.length > 0">
      <template v-for="thread in $store.state.notifications.threads" :key="thread.id" :label="thread.threadName">
        <div class="flex justify-content-between align-items-center thread" :class="{'current-thread': thread.id === this.currentThread.id}">
            <div class="thread-info">
              {{thread.threadName}}
            </div>
          <div class="thread-actions flex">
            <button @click="showThread(thread)" class="mr-1 p-button p-component p-button-icon-only p-button-rounded p-button-success" type="button">
              <span class="pi pi-comment p-button-icon"></span>
              <span class="p-button-label">&nbsp;</span>
              <span class="p-ink"></span>
            </button>
            <button @click="$router.push({ name: 'notifications', query: { thread: thread.id } })" class="mr-1 p-button p-component p-button-icon-only p-button-rounded p-button-primary" type="button">
              <span class="pi pi-envelope p-button-icon"></span>
              <span class="p-button-label">&nbsp;</span>
              <span class="p-ink"></span>
            </button>
            <button @click="$router.push(`/threads/${thread.id}`)" class="p-button p-component p-button-icon-only p-button-rounded p-button-warning" type="button">
              <span class="pi pi-cog p-button-icon"></span>
              <span class="p-button-label">&nbsp;</span>
              <span class="p-ink"></span>
            </button>
          </div>
        </div>
      </template>
    </div>
    <div class="col-9 pl-0">
      <template v-if="this.currentThread">
          <div class="card p-0 flex flex-column justify-content-between card-thread">
            <div class="thread-header">
              <span><b>{{$t('thread.validityPeriod')}}: </b>{{ `${$t('from')} ${utils.formatDateTime(utils.dateToCurrentTimeZone(this.currentThread.validFrom))} ${$t('to')} ${utils.formatDateTime(utils.dateToCurrentTimeZone(this.currentThread.validTo))}` }}</span>
              <div class="flex mt-2">
                <b>{{$t('thread.partecipants')}}: </b>
                <div class="partecipants">
                  <template v-for="user in this.currentThread?.users" :key="user">
                    <span class="p-badge p-badge-success mx-1 badge">{{ user }}</span>
                  </template>
                </div>
              </div>
            </div>
            <div ref="widgetChat" class="widget-chat overflow-auto">
              <ul>
                <template v-for="notification in this.currentThread?.sysUsersNotifications" :key="notification.id">
                  <div :class="notification.sender == this.$store.state.security.user.email ? 'text-right' : 'text-left'">
                  </div>
                  <li :class="notification.sender == this.$store.state.security.user.email ? 'message-own' : 'message-from'"><img src="img/avatar.png">
                    <div class="message">
                      <p class="m-0"><b>{{notification.notificationObject}}</b></p>
                      <span v-html="notification.notificationText"></span>
                      <p class="sender"><b>{{notification.sender}} {{utils.formatDateTime(utils.dateToCurrentTimeZone(notification.notificationDate), 'DD/MM/yy HH:mm')}}</b></p>
                    </div>
                  </li>
                </template>
              </ul>
            </div>
        </div>
      </template>
      <template v-else>{{ $t('thread.noThreadSelected') }}</template>
    </div>
  </div>
</template>

<style lang="scss">


.message-header {
  color: grey;
}

.partecipants {
  display: flex;
  align-items: center;
  overflow-x: auto;
  flex: 1;
  padding-bottom: 4px;
}

.badge {
  display: table;
}

.thread-header{
  border-bottom: 2px solid #dee2e6;
  padding: 1.25rem;
}

.sender {
  color: grey;
  font-size: 12px;
  text-align: right;
}

.receiver {
  margin-right: 20%;
  border-radius: 20px 20px 20px 0;
}

.p-autocomplete {
  .p-autocomplete-multiple-container {
    width: 100%;
  }
}

.layout-content:has(.grid-thread) {
  display: flex;
  flex-direction: column;

  .grid-thread {
    flex: 1;
  }
  .card-thread {
    height: calc(100vh - 166px);
  }
}

.thread-info {
  font-size: 1.25rem;
  font-weight: 700;
  width: calc(100% - 110px);
  overflow-wrap: break-word;
}

.thread{
  border-bottom: 1px solid #dee2e6;
  padding: 1rem;
  transition: background-color .2s linear;
}

.thread-actions{
  width: 105px;
}

.current-thread{
  background-color: #dff0d8;
}

.widget-chat{
  flex: 1;
  display: flex;
  align-items: flex-end;
  background-color: #f1f1e98f;
}
</style>